import { useContext } from "react";
import { useHistory } from "react-router-dom";
import useNavigationUrl from "@common/hooks/useNavigationUrl";
import { useAssignmentProposalStore } from "@context/useAssignmentProposalStore";
import { AppContext } from "../context/EditSessionsContext";

/**
 * "Finalizar" after saving a draft or sending a proposal: back to the page the editor was opened
 * from. An editor opened for a proposal knows it (`returnTo`, replacing the editor entry); a
 * regular entry goes back in the history, as a direct save does, or, without history, to the link.
 */
export const useFinishProposalEdition = () => {
  const history = useHistory();
  const { state } = useContext(AppContext);
  const { editorUrl } = useNavigationUrl();
  const returnTo = useAssignmentProposalStore(store => store.editorReturnTo);
  const linkId = state?.link?.info?.id;

  return () => {
    if (returnTo) history.replace(returnTo);
    else if (history.length > 1) history.goBack();
    else if (linkId) {
      history.push(editorUrl("link", String(linkId)), {
        currentSelectedWeek: state?.link?.selectedWeek,
      });
    }
  };
};
